// extracted by mini-css-extract-plugin
export default {"container":"ImplantImageComponent_container__SrdpB","image":"ImplantImageComponent_image__dfmnC"};